import { QuickAccessPage } from '../../interfaces/ui/quick-access.interface';

export function elevatedSlotIndex(slots: (QuickAccessPage | null)[]): number | null {
  const filledIndexes = slots.reduce<number[]>((indexes, slot, index) => {
    if (slot) indexes.push(index);
    return indexes;
  }, []);

  if (filledIndexes.length === 0 || filledIndexes.length % 2 === 0) return null;

  return filledIndexes[(filledIndexes.length - 1) / 2];
}
